// Copyright (C) 2019 TANNER AG

import React, { useContext, useState } from "react";
import { compose } from "recompose";
import { withStore } from "../store/withstore";
import { Query } from "react-apollo";
import busQuery from "../queries/buses";
import { withStyles, Grid } from '@material-ui/core'
import { Button } from "../components/button";
import BusItem from "./busitem";
import { TranslationContext } from "../translation";
import { withRouter } from "react-router-dom";
import { Spinner } from "../components/spinner";
import SwipeableViews from "react-swipeable-views";
import Header from "./header";
import { Error } from "../components/error";

const styles = {
	wrapper: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		margin: "40px 100px 0"
	},
	title: {
		color: "#303C49",
		fontFamily: "'MANEurope', sans-serif",
		fonWeight: 300,
		fontSize: "22px",
		lineHeight: "30px",
		textAlign: "center",
		marginTop: "30px",
		letterSpacing: "-0.1px"
	},
	section: {
		textAlign: "center"
	}
};

const CustomGrid = withStyles({
	container: {}
})(Grid);

const Entry = (props) => {
	const { translate } = useContext(TranslationContext);
	const { store: { a, b }, storeAction, history } = props;
	const startEnabled = Boolean(a.bus.id && b.bus.id);

	const [index, setIndex] = useState(0);

	const selectBusA = (bus) => {
		storeAction.addBus(bus, "A");

		// Switch only to B if bus a is set
		if (a.bus.id) {
			setIndex(1);
		}
	};

	const selectBusB = (bus) => {
		storeAction.addBus(bus, "B");
	};

	return (
		<div className={props.classes.wrapper}>
			<Header index={index} onItemClick={setIndex}/>
			<Query query={busQuery} fetchPolicy="network-only">
				{({ loading, error, data }) => {
					if (loading) {
						return <Spinner/>;
					}

					if (error) {
						return (
							<Error
								message={error}
							/>
						);
					}

					return (
						<SwipeableViews
							index={index}
							springConfig={{
								duration: '1s',
								easeFunction: 'cubic-bezier(0.15, 0.3, 0.25, 1)',
								delay: '0.3s',
							}}
							style={{ overflow: "hidden" }}
							slideStyle={{ overflow: 'hidden' }}
						>
							<CustomGrid container spacing={8}>
								{data.tcoBuses.map((bus) => (
									<BusItem
										key={bus.id}
										bus={bus}
										onClick={() => selectBusA(bus)}
										active={a.bus.id === bus.id}
										disable={Boolean(a.bus.id)}
									/>
								))}
							</CustomGrid>
							<CustomGrid container spacing={8}>
								{data.tcoBuses.map((bus) => (
									<BusItem
										key={bus.id}
										bus={bus}
										onClick={() => selectBusB(bus)}
										active={b.bus.id === bus.id}
										disable={Boolean(b.bus.id)}
									/>
								))}
							</CustomGrid>
						</SwipeableViews>
					);
				}}
			</Query>
			<div className={props.classes.section} style={{ marginTop: "2rem" }}>
				<Button
					variant="contained"
					size="large"
					disabled={!startEnabled}
					onClick={() => history.push("/tco-lcc/defaultparameters")}
				>
					{translate("calculator.start")}
				</Button>
			</div>
		</div>
	);
};

export default compose(
	withStore,
	withRouter,
	withStyles(styles)
)(Entry);



// WEBPACK FOOTER //
// ./src/tco/entry/index.js